"use client"

import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import "./Login.css"

const Login = () => {
  const [phone, setPhone] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { login } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)

    const result = await login(phone, password)

    if (result.success) {
      navigate("/")
    } else {
      setError(result.error)
    }

    setLoading(false)
  }

  return React.createElement(
    "div",
    { className: "login-container" },
    React.createElement(
      "div",
      { className: "login-card" },
      React.createElement(
        "div",
        { className: "login-header" },
        React.createElement("h1", null, "Vireliosoft"),
        React.createElement("p", null, "İşletme Yönetim Platformu"),
      ),
      error && React.createElement("div", { className: "error-message" }, error),
      React.createElement(
        "form",
        { onSubmit: handleSubmit },
        React.createElement(
          "div",
          { className: "input-group" },
          React.createElement("label", null, "Telefon Numarası"),
          React.createElement("input", {
            type: "text",
            value: phone,
            onChange: (e) => setPhone(e.target.value),
            placeholder: "5551234567",
            required: true,
            disabled: loading,
          }),
        ),
        React.createElement(
          "div",
          { className: "input-group" },
          React.createElement("label", null, "Şifre"),
          React.createElement("input", {
            type: "password",
            value: password,
            onChange: (e) => setPassword(e.target.value),
            placeholder: "••••••••",
            required: true,
            disabled: loading,
          }),
        ),
        React.createElement(
          "button",
          { type: "submit", className: "btn btn-primary btn-block", disabled: loading },
          loading ? "Giriş yapılıyor..." : "Giriş Yap",
        ),
      ),
      React.createElement(
        "div",
        { className: "login-footer" },
        React.createElement("p", null, "Vireliosoft tüm hakları saklıdır"),
      ),
    ),
  )
}

export default Login
